export const BASE_PATH_SEPARATOR = '_' as const;
